
<template>
    <div class="container1">
		<div class="name-box">
			<div class="input-box">
				<span style="font-size:14px">客户名称：{{customerName}}</span>
			</div>
		</div>
		<div class="btn-pay-box">
			<span>支付方式：</span>
			<el-select v-model="paymodes" multiple :disabled="isDisabled" @change="changeMethod" collapse-tags class="select-box" size='mini' placeholder="请选择支付方式">
				<el-option value='2' label="微信支付"></el-option>
				<el-option value='0' label="线下支付"></el-option>
				<el-option value='4' label="预付货款"></el-option>
				<el-option value='6' label="微企付"></el-option>
				<el-option value='7' label="云资金-网商余额支付"></el-option>
				<el-option value='8' label="云资金-汇付支付"></el-option>
				<el-option value='11' label="B2b门店助手-微信支付"></el-option>
				<el-option value='12' label="B2b门店助手-银行转账"></el-option>
				<el-option value='13' label="云资金-网商收银台"></el-option>
				<el-option value='14' label="拉卡拉全渠道-余额支付"></el-option>
				<el-option value='16' label="拉卡拉钱包余额"></el-option>
				<!-- // TODO 过滤拉卡拉全渠道-收银台 -->
<!--				<el-option value='15' label="拉卡拉全渠道-收银台"></el-option>-->
			</el-select>
			<span style="margin:0 10px">好友代付</span>
			<el-switch v-model="friendpay" :disabled="isDisabled" @change="otherPay" :active-color="$fxPrimaryColor" inactive-color="#dcdfe6"></el-switch>
			<span style="margin-left:10px">注：目前好友代付仅支持客户支付方式为微信支付、微企付、B2b门店助手-微信支付、B2b门店助手-银行转账</span>
		</div>
		<div class="btn-pay-box">
			<span>退款方式设置：</span>
		</div>
		<div class="table-box">
			<div class="table-row" style="background:  #f0f3fa;padding: 10px 20px;">
				<span style="width:50%;">支付方式</span>
				<span class="select-box2">退款方式</span>
			</div>
			<div class="table-row">
				<span style="width:50%;">微信支付</span>
				<el-select v-model="wechatPaymodes" :disabled="isDisabled" @change="changeWechatPaymodes(1)" collapse-tags class="select-box2" size='mini' placeholder="请选择退货方式">
					<el-option value="0" label="原路返回"></el-option>
					<el-option value="1" label="退回预付货款"></el-option>
			</el-select>
			</div>
			<div class="table-row">
				<span style="width:50%;">线下支付</span>
				<el-select v-model="offlinePaymodes" disabled class="select-box2" size='mini' placeholder="请选择退货方式">
					<el-option value="0" label="原路返回"></el-option>
			</el-select>
			</div>
			<div class="table-row">
				<span style="width:50%;">预付货款支付</span>
				<el-select v-model="prePaymodes" disabled class="select-box2" size='mini' placeholder="请选择退货方式">
					<el-option value="0" label="原路返回"></el-option>
				</el-select>
			</div>
			<div class="table-row">
				<span style="width:50%;">微企付支付</span>
				<el-select v-model="tenpayflag" :disabled="isDisabled" @change="changeWechatPaymodes(2)" class="select-box2" size='mini' placeholder="请选择退货方式">
					<el-option value="0" label="原路返回"></el-option>
					<el-option value="1" label="退回预付货款"></el-option>
				</el-select>
			</div>
			<div class="table-row">
				<span style="width:50%;">云资金-网商余额支付</span>
				<el-select v-model="prePaymodes" disabled class="select-box2" size='mini' placeholder="请选择退货方式">
					<el-option value="0" label="原路返回"></el-option>
				</el-select>
			</div>
			<div class="table-row">
				<span style="width:50%;">云资金-汇付支付</span>
				<el-select v-model="prePaymodes" disabled class="select-box2" size='mini' placeholder="请选择退货方式">
					<el-option value="0" label="原路返回"></el-option>
				</el-select>
			</div>
			<div class="tip-row">
				1、到账周期为D+0的，不支持退款原路返回<br>
				2、网关渠道为招行、中行时，支持退款原路返回，但退款资金到账时间有差异，为D+1到账
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'table-box',
	components: {
	},
	props: {
		id: String
	},
	data () {
		return {
			isDisabled: true,
			paymodes: [],
			orginPaymodes: [],
			wechatPaymodes: '',
			offlinePaymodes: '0',
			prePaymodes: '0',
			tenpayflag: '0',
			suppliercustomerId: '',
			showPaymodeFlag: false,
			AuthorityList: {
				'03_0001_0001_00': false,
				'03_0001_0002_00': false,
				'03_0001_0003_00': false,
				'03_0001_0004_00': false,
				'03_0001_0005_00': false,
				'03_0001_0006_00': false,
				'03_0001_0007_00': false,
				'03_0001_0008_00': false,
				'03_0001_0009_00': false,
				'03_0001_0010_00': false,
				'03_0001_0011_00': false
			},
			supplierconsumerId: '',
			friendpay: false,
			openflag: '1'
		}
	},
	created () {
		this.customerName = window.sessionStorage.getItem('customerName')
		this.getAuthority('03_0001_0000_00')
		this.tableReload()
	},
	methods: {
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					let add = window.sessionStorage.getItem('isCustomerAdd')
					if (add === 'true') {
						if (this.AuthorityList['03_0001_0005_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					} else {
						if (this.AuthorityList['03_0001_0003_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					}
				}
			})
		},
		changeMethod () {
			let list = []
			let has2 = this.paymodes.indexOf('2') !== -1
			let has6 = this.paymodes.indexOf('6') !== -1
			let orginHas2 = this.orginPaymodes.indexOf('2') !== -1
			let orginHas6 = this.orginPaymodes.indexOf('6') !== -1
			if (!orginHas6 && has6) {
				this.paymodes.forEach(item => {
					if (item !== '2') {
						list.push(item)
					}
				})
				this.paymodes = list
			}
			if (!orginHas2 && has2) {
				this.paymodes.forEach(item => {
					if (item !== '6') {
						list.push(item)
					}
				})
				this.paymodes = list
			}
			let params = {
				id: window.sessionStorage.getItem('customerid'),
				paymodes: this.paymodes.join(','),
				name: this.customerName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/updateCustomerShopPayMode`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableReload()
				} else {
					this.$message.error(res.msg)
					this.tableReload()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		otherPay (e) {
			let params = {
				customerIds: [window.sessionStorage.getItem('customerid')],
				payByFriendFlag: e ? '1' : '0'
			}
			let changeData = {
				pre: { lineSelect14: { type: '1' } },
				cur: { lineSelect14: { type: '2', customerName: this.customerName, status: e ? '开启好友代付' : '关闭好友代付' } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/batchUpdateCustomerPayByFriendFlag`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success((e ? '开启' : '关闭') + '好友代付成功')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		changeWechatPaymodes (type) {
			let params = {
				id: window.sessionStorage.getItem('customerid'),
				suppliercustomerid: this.supplierconsumerId,
				name: this.customerName
			}
			if (type === 1) {
				params.wechatflag = this.wechatPaymodes
			} else if (type === 2) {
				params.tenpayflag = this.tenpayflag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/updateCustomerRefundPayMode`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		tableReload () {
			let params = {
				id: window.sessionStorage.getItem('customerid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/findCustomerShopPaymode`,
				data: params
			}).then(res => {
				if (res.result) {
					this.paymodes = res.data[0].paymodes
					this.orginPaymodes = res.data[0].paymodes
					this.orgname = res.data[0].orgname
					this.wechatPaymodes = res.data[0].wechatflag + ''
					this.supplierconsumerId = res.data[0].supplierconsumerId
					this.friendpay = res.data[0].payByFriendFlag === 1
					this.tenpayflag = res.data[0].tenpayflag + ''
					this.openflag = res.data[0].openflag + ''
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.container1{
	// min-width: 730px;
	width: 100%;
	flex-direction: column !important;
	height:calc(100% - 20px) ;
	.name-box{
		padding-bottom :10px;
		margin-top :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		border-bottom 1px solid #dce2fd
		.input-box{
			padding-left:20px;
			text-align :left
			overflow-x :hidden
			margin-bottom:10px
		}
	}
	.search-box{
		padding-bottom :10px;
		margin-top :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		border-bottom 1px solid #dce2fd
		.input-box-btn{
			width :80px;
		}
		.input-box{
			text-align :left;
			padding-left:20px;
			width :280px;
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:150px;
				margin-right:10px;
			}
		}
	}
	.btn-pay-box{
		margin-top:30px;
		display :flex
		align-items: center;
		padding-left: 20px;
	}
	.table-box{
    width: 450px;
		margin-top: 30px;
		.table-row {
			display: flex;
			align-items: center
			justify-content: space-around;
			text-align: left;
			margin: 20px 20px;
			padding: 0 20px;
			.select-box2{
				width:50%;
				margin-right: 70px;
			}
		}
		.tip-row {
			color: red
			text-align: left;
			padding-left: 40px;
			font-size: 14px;
			line-height: 25px;
		}
	}
}

</style>
<style lang="stylus">
</style>
